var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"4"}}),_c('b-col',[_c('b-jumbotron',{attrs:{"header":"404","lead":"A página que você esta tentando acessar não foi encontrada.","bg-variant":"default","text-variant":"dark","border-variant":"dark"}})],1),_c('b-col',{attrs:{"md":"4"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }